import AccountAcceptInvite from "pages/Account/AcceptInvite";
import AccountForgotPassword from "pages/Account/ForgotPassword";
import AccountResetPassword from "pages/Account/ResetPassword";
import Login from "pages/Login";
import { RouteType } from "routes/types";
import { APP_URLS } from "settings";

const UNAUTHENTICATED_ROUTES: RouteType[] = [
  {
    path: APP_URLS.ACCOUNT.ACCEPT_INVITE,
    component: AccountAcceptInvite,
    title: "Accept invite",
  },
  {
    path: APP_URLS.ACCOUNT.RESET_PASSWORD,
    component: AccountResetPassword,
    title: "Reset password",
  },
  {
    path: APP_URLS.ACCOUNT.FORGOT_PASSWORD,
    component: AccountForgotPassword,
    title: "Forgot password",
  },
  {
    path: APP_URLS.LOGIN,
    component: Login,
    title: "Log in",
  },
];

export default UNAUTHENTICATED_ROUTES;
